import { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { Icon, IconKey } from '@sr/ui-library';
import { Button, Tooltip } from 'react-daisyui';
import { twMerge } from 'tailwind-merge';

export interface IIconButtonProps {
  className?: string;
  icon: IconKey | PhosphorIcon;
  iconClassName?: string;
  iconColor?:
    | 'accent'
    | 'error'
    | 'ghost'
    | 'info'
    | 'neutral'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning';
  iconSize?: string;
  label: string;
  onClick?: () => void;
  tipPosition?: 'bottom' | 'left' | 'right' | 'top' | undefined;
}

const IconButton = ({
  className,
  icon,
  iconClassName,
  iconColor = 'ghost',
  iconSize = '2',
  label,
  onClick,
  tipPosition = 'top',
}: IIconButtonProps) => {
  return (
    <Tooltip message={label} position={tipPosition}>
      <Button
        className={className}
        color={iconColor}
        shape="circle"
        onClick={() => {
          if (onClick) onClick();
        }}
      >
        <Icon
          className={twMerge(
            iconClassName ? iconClassName : '',
            `size-${iconSize}`,
          )}
          icon={icon}
        />
      </Button>
    </Tooltip>
  );
};

export default IconButton;
